<template>
  <div>
    <v-container fluid>
      <v-row justify="center">
        <v-col lg="8">
          <v-card class="card--shadow">
            <v-card-text>
              <v-row>
                <v-col class="col--padding" offset-lg="2" lg="4">
                  <label>Month</label>
                  <v-select
                    class="mr-1"
                    :items="months"
                    v-model="month"
                    item-text="text"
                    :error-messages="monthValidation"
                    item-value="value"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="col--padding" lg="4">
                  <label>Year</label>
                  <v-select
                    class="mr-1"
                    :items="years"
                    v-model="year"
                    item-text="text"
                    item-value="value"
                    :error-messages="yearValidation"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="col--padding" lg="3">
                  <div>
                    <v-btn
                      height="40"
                      color="purple accent-4"
                      @click.prevent="goActivityList"
                      outlined
                      rounded
                      dark
                    >
                      Go Activity
                      <v-icon right>mdi-arrow-right-thick</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-container class="feedback" fluid>
        <h3>Uncompleted done list for each activity :</h3>
        <v-row justify="center">
          <!-- <v-col md="3">
            <v-card  @click="getUncompletedList('he-uncompleted',feedbackCount.he.items)" class="card--shadow feedback-count">
              <p class="teal--text">HE</p>
              <v-chip class="ma-2 count white--text" color="orange lighten-1">
                {{ feedbackCount.he.count }}
              </v-chip>
            </v-card>
          </v-col> -->
          <v-col md="3">
            <v-card  @click="getUncompletedList('home-visit-uncompleted',feedbackCount.homevisit.items)" class="card--shadow feedback-count">
              <p class="orange--text">Home Visit</p>
              <v-chip class="ma-2 count white--text" color="orange lighten-1">
                {{ feedbackCount.homevisit.count }}
              </v-chip>
            </v-card>
          </v-col>
          <v-col md="3">
            <v-card  @click="getUncompletedList('supervision-uncompleted',feedbackCount.supervision.items)" class="card--shadow feedback-count">
              <p class="indigo--text">SuperVision</p>
              <v-chip class="ma-2 count white--text" color="orange lighten-1">
                {{ feedbackCount.supervision.count }}
              </v-chip>
            </v-card>
          </v-col>
          <v-col md="3">
            <v-card  @click="getUncompletedList('counseling-uncompleted',feedbackCount.counseling.items)" class="card--shadow feedback-count">
              <p class="light-green--text">Counseling</p>
              <v-chip class="ma-2 count white--text" color="orange lighten-1">
                {{ feedbackCount.counseling.count }}
              </v-chip>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
export default {
  mixins: [ValidationMixin],
  data: () => ({
    month: null,
    year: null,
  }),
  validations: {
    month: {
      required,
    },
    year: {
      required,
    },
  },
  methods: {
    goActivityList() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$router.push({
          name: "activity-list",
          params: { month: this.month, year: this.year },
        });
      }
    },
     getUncompletedList(linkName,items) {
      const idSet = items.map((v) => v.item_id)
      this.$router.push({
        name: linkName,
       query:{values:JSON.stringify(idSet)}
      });
    },
  },
  created() {
    this.$store.dispatch("Feedback/getCount", {
      done: 0,
      author_type: "ADMIN",
      township_id: this.admin.township_id,
    });
  },
  computed: {
    ...mapState("InitialData", ["months", "years"]),
    ...mapState("Feedback", ["feedbackCount"]),
    ...mapState("Admin", ["admin"]),
    monthValidation() {
      return this.handleFieldErrors(this.$v.month);
    },
    yearValidation() {
      return this.handleFieldErrors(this.$v.year);
    },
  },
};
</script>

<style>
.feedback h3 {
  padding: 5px 8px;
  font-weight: 400;
}
.feedback-count {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.feedback-count p {
  border-radius: 100%;
  font-size: 20px;
  margin-bottom: 0px;
  margin: 5px 0px;
}
.count {
  color: black !important;
  font-size: 18px !important;
}
</style>
